import { FC, useContext } from "react";
import { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";

import HubInputField from "../inputType";
import useFetch from "src/hooks/useFetch";

import { CaseFilterForm, CaseFilterProps, PracticeDoctorResponseType } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import { AuthContext } from "src/context/authContext";
import StatsReports from "../manufacturer/statsReports";


const TableFilters: FC<CaseFilterProps> = ({ handleSearchWithQueryParams, state, dropdownData, inputPlaceholder, dispatch, handleSearchWithQueryParam, onClearButtonClicked }): JSX.Element => {
  const { control, handleSubmit,getValues } = useForm<CaseFilterForm>({
    mode: 'all',
  });

  const { isManufacturer} = useContext(AuthContext);
  console.log("state in case filters", state, isManufacturer);



  const { data: doctorPracticeData } =
    useFetch<PracticeDoctorResponseType>(APIEndpoints.PRACTICE_DOCTOR_DROPDOWN);


  

  const searchForData = (values: CaseFilterForm) => {
    handleSearchWithQueryParams && handleSearchWithQueryParams(values);
  };

  return (
    <form onSubmit={handleSubmit(searchForData)}>
      <div className="row g-2 p-2">
        <div className="col-md-6">
          <div className="row g-2">
            <div className="col-4">
              <Controller
                name="start_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <HubInputField
                    inputId="start_date"
                    isRowBased={false}
                    isRequired={false}
                    field={field}
                    inputType="date"
                  />
                )}
              />
            </div>

            <div className="col-4">
              <Controller
                name="end_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <HubInputField
                    inputId="end_date"
                    isRowBased={false}
                    isRequired={false}
                    field={field}
                    inputType="date"
                  />
                )}
              />
            </div>

            <div className="col-4">
              <Controller
                name="practice_id"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <HubInputField
                    isRequired={false}
                    isRowBased={false}
                    inputId="practice_id"
                    defaultValue="No Practice Found"
                    field={field}
                    isDropdown={true}
                    isSearchable={true}
                    dropdownData={
                      (
                        doctorPracticeData && doctorPracticeData.data && doctorPracticeData.data.practices ?
                          doctorPracticeData.data.practices.map((prac) => ({ value: prac.id, label: prac.name }))
                          : []
                      ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row g-2">
            <div className="col-8">

              <div className="row g-2">
                <div className="col-6">
                  <Controller
                    name="global_doctor_id"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <HubInputField
                        isRequired={false}
                        isRowBased={false}
                        inputId="global_doctor_id"
                        defaultValue="No Doctor Found"
                        field={field}
                        isDropdown={true}
                        isSearchable={true}
                        dropdownData={
                          (doctorPracticeData && doctorPracticeData.data && doctorPracticeData.data.doctors ?
                            doctorPracticeData.data.doctors.map((doc) => ({ value: doc.id, label: doc.name })) : []
                          ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                        }
                      />
                    )}
                  />
                </div>

                <div className="col-3">
                  <Controller
                    name="global_patient_id"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <HubInputField
                        inputId="global_patient_id"
                        isRowBased={false}
                        isRequired={false}
                        field={field}
                        inputPlaceholder="Pt. ID"
                      />
                    )}
                  />
                </div>

                <div className="col-3">
                  <Controller
                    name="case_id"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <HubInputField
                        inputId="case_id"
                        isRowBased={false}
                        isRequired={false}
                        field={field}
                        inputPlaceholder="Case ID"
                      />
                    )}
                  />
                </div>
              </div>

            </div>

            <div className="col-2">
              <button
                type="submit"
                className="btn btn-primary btn-md w-100 rounded-0 ps-1 pe-1"
              >
                <i className="bi bi-arrow-repeat"></i> Refresh
              </button>
            </div>

            <div className="col-2">
              <button type="button" onClick={onClearButtonClicked} className="btn btn-light btn-md w-100 rounded-0 ps-1 pe-1">
                Clear
              </button>
            </div>
            
          </div>
          
        </div>
        {isManufacturer  && <div className="row align-items-center">
          <div className="col-12">
            <StatsReports getValues={getValues}/>
          </div>
        </div> }
      </div>
    </form>
  );
};

export default TableFilters;
